/* eslint-disable import/no-cycle */
import React from 'react';
import AssociateView from '../components/AssociateView';

const AssociateLayout = () => (
  <AssociateView currentAssociate={localStorage.getItem('currentAssociate')} />
);

export default AssociateLayout;
